import Capital from './Capital';
import DashboardRevamp from './DashboardRevamp';
import IneligibleTermLoan from './Ineligible/TermLoan/IneligibleTermLoan';
import IneligibleInvestment from './Ineligible/Investment/IneligibleInvestment';
import IneligibleFastLoan from './Ineligible/FastLoan/IneligibleFastLoan';
import StatusInvestment from './Status/Investment';
import StatusFastLoan from './Status/FastLoan';
import FastLoan from './FastLoan';
import Investment from './Investment';
import TermLoan from './TermLoan';
import FastLoanTenor from './FastLoan/Tenor';

export {
  DashboardRevamp,
  IneligibleTermLoan,
  IneligibleInvestment,
  IneligibleFastLoan,
  StatusInvestment,
  StatusFastLoan,
  FastLoan,
  Investment,
  TermLoan,
  FastLoanTenor,
};

export default Capital;
